// extracted by css-extract-rspack-plugin
export default {"Box":"no-iterations-placeholder-module__Box__HLzUx","Text":"no-iterations-placeholder-module__Text__LE2qQ","Text_1":"no-iterations-placeholder-module__Text_1__Hz2a9"};